import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getVariant, propToText, toText } from '../layout.js';
import { cn } from '../lib/utils.js';
export function Toast({ element }) {
    const { children, props, content } = element;
    const variant = getVariant(props);
    const title = propToText(props.title) || toText(content);
    const description = propToText(props.description);
    const icon = propToText(props.icon);
    // Variant styles
    const variantStyles = {
        default: 'bg-card border-border',
        success: 'bg-success/10 border-success text-success',
        warning: 'bg-warning/10 border-warning text-warning',
        danger: 'bg-destructive/10 border-destructive text-destructive',
        info: 'bg-accent/10 border-accent text-accent',
    };
    const variantIconColor = {
        default: 'text-foreground',
        success: 'text-success',
        warning: 'text-warning',
        danger: 'text-destructive',
        info: 'text-accent',
    };
    // Default icons per variant
    const defaultIcons = {
        success: '✓',
        warning: '⚠',
        danger: '✕',
        info: 'ℹ',
    };
    const displayIcon = icon || (variant && defaultIcons[variant]);
    const styleKey = (variant || 'default');
    // If has children, render custom toast content
    if (children && children.length > 0) {
        return (_jsx("div", { className: cn('flex items-start gap-3 p-4 border rounded-lg shadow-lg', 'animate-in slide-in-from-top-2 fade-in-0', variantStyles[styleKey]), role: "alert", style: {
                width: props.width ? String(props.width) : undefined,
                maxWidth: '400px',
            }, children: children.map((child, i) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, i)))) }));
    }
    return (_jsxs("div", { className: cn('flex items-start gap-3 p-4 border rounded-lg shadow-lg', 'animate-in slide-in-from-top-2 fade-in-0', variantStyles[styleKey]), role: "alert", style: {
            width: props.width ? String(props.width) : undefined,
            maxWidth: '400px',
        }, children: [displayIcon && (_jsx("span", { className: cn('text-lg flex-shrink-0', variantIconColor[styleKey]), children: displayIcon })), _jsxs("div", { className: "flex-1 min-w-0", children: [title && (_jsx("div", { className: cn('font-medium', variant ? variantIconColor[styleKey] : 'text-card-foreground'), children: title })), description && _jsx("div", { className: "text-sm text-muted-foreground mt-1", children: description })] })] }));
}
//# sourceMappingURL=Toast.js.map